"use strict";
angular.module("backArticleServiceModule", [
    "backArticleModule", //新建角色
]).
factory("backArticleService", ["$modal", "$q", function($modal, $q) {
    return {
        /**
         * [createProduct description] 退回稿件
         * @param {[string]} [userId] [description] 
         */
        backArticle: function() {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./main/backstage/pgcManage/documentDetail/service/backArticle/backArticle_tpl.html",
                windowClass: 'backArticle backstageModalHeader',
                backdrop: false,
                controller: "backArticleCtrl",
                resolve: {
                    
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        }
    };
}]);